<template>
  <div>

    <!-- Text that displays 'ZOOM' -->
    <div class="zoom-text">ZOOM</div>

    <!-- Text that displays the zoom level -->
    <div class="zoom-level-text" @click="$emit('click')">{{ Math.floor(zoomLevel) }}</div>

    <!-- Range input zoom slider -->
    <div :class="'zoom-input-field' + (expanded ? ' active' : '')">
      <vue-slider v-model="newZoomLevel" v-bind="sliderOptions" class="no-drag">
        <template v-slot:dot>
          <div class="custom-drag-dot"></div>
          <div class="custom-drag-dot-circle custom-drag-dot-circle-top-left"></div>
          <div class="custom-drag-dot-circle custom-drag-dot-circle-top-center"></div>
          <div class="custom-drag-dot-circle custom-drag-dot-circle-top-right"></div>
          <div class="custom-drag-dot-circle custom-drag-dot-circle-bottom-left"></div>
          <div class="custom-drag-dot-circle custom-drag-dot-circle-bottom-center"></div>
          <div class="custom-drag-dot-circle custom-drag-dot-circle-bottom-right"></div>
        </template>
      </vue-slider>
    </div>

  </div>
</template>

<style scoped>
.custom-drag-dot {
  cursor: pointer;
  position: relative;
  width: 26px;
  height: 60px;
  top: -60%;
  right: 45%;
  border-radius: 0;
  background-color: rgba(255, 255, 255, 0.7);
}
.custom-drag-dot-circle {
  cursor: pointer;
  position: relative;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.8);
}
.custom-drag-dot-circle-top-left {
  position: absolute;
  top: 260%;
  right: 80%;
}
.custom-drag-dot-circle-top-center {
  position: absolute;
  top: 260%;
  right: 30%;
}
.custom-drag-dot-circle-top-right {
  position: absolute;
  top: 260%;
  right: -20%;
}
.custom-drag-dot-circle-bottom-left {
  position: absolute;
  top: 310%;
  right: 80%;
}
.custom-drag-dot-circle-bottom-center {
  position: absolute;
  top: 310%;
  right: 30%;
}
.custom-drag-dot-circle-bottom-right {
  position: absolute;
  top: 310%;
  right: -20%;
}
/* Scales with viewport width: 240px on small screens up to 330px on large */
.zoom-input-field {
  width: clamp(240px, 16vw, 330px);
}
.zoom-input-field {
  color: white;
  font-size: 17px;
  padding-top: 5px;
  position: absolute;
  top: 44px;
  left: 30px;
  opacity: 0;
  visibility: hidden;
  transition: opacity 100ms ease, visibility 0s ease 100ms;
}
.zoom-input-field.active {
  opacity: 1;
  visibility: visible;
  transition: opacity 1.25s ease, visibility 0s ease 0s;
}
.zoom-level-text {
  color: white;
  cursor: pointer;
  font-size: 70px;
  font-weight: 600;
  position: absolute;
  right: 16px;
  top: 6%;
}
.zoom-text {
  color: white;
  font-size: 13px;
  padding-top: 5px;
  position: absolute;
  right: 66px;
}
</style>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

export default {
  name: 'MMP_CollapsedZoom',
  components: {
    VueSlider
  },
  props: ['expanded', 'map', 'zoomLevel'],
  data() {
    return {
      newZoomLevel: 3,
      sliderOptions: {
        interval: 0.25,
        min: 3,
        max: 28,
        marks: {
          '5': {
            label: 'Country',
            labelStyle: {
              fontSize: '16px',
              top: '-1300%'
            },
            style: {
              display: 'block',
              transform: 'translate(0px, -11px)',
              width: '1px',
              height: '26px',
              border: '0',
              borderRadius: '0%'
            }
          },
          '9': {
            label: 'Mid Zoom',
            labelStyle: {
              color: '#b5b5b5',
              fontSize: '13px',
              top: '370%'
            },
            style: {
              backgroundColor: '#606060',
              display: 'block',
              transform: 'translate(0px, -11px)',
              width: '1px',
              height: '26px',
              border: '0',
              borderRadius: '0%',
              boxShadow: '0 0 0 2px #b5b5b5'
            }
          },
          '13': {
            label: 'City',
            labelStyle: {
              fontSize: '16px',
              top: '-1300%'
            },
            style: {
              display: 'block',
              transform: 'translate(0px, -11px)',
              width: '1px',
              height: '26px',
              border: '0',
              borderRadius: '0%'
            }
          },
          '16': {
            label: 'High Zoom',
            labelStyle: {
              color: '#b5b5b5',
              fontSize: '13px',
              top: '370%'
            },
            style: {
              backgroundColor: '#606060',
              display: 'block',
              transform: 'translate(0px, -11px)',
              width: '1px',
              height: '26px',
              border: '0',
              borderRadius: '0%',
              boxShadow: '0 0 0 2px #b5b5b5'
            }
          },
          '20': {
            label: 'Street',
            labelStyle: {
              fontSize: '16px',
              top: '-1300%'
            },
            style: {
              display: 'block',
              transform: 'translate(0px, -11px)',
              width: '1px',
              height: '26px',
              border: '0',
              borderRadius: '0%'
            }
          },
          '3': {
            // Left-end hash mark
            label: '',
            style: {
              display: 'block',
              transform: 'translate(0px, -6px)',
              width: '1px',
              height: '16px',
              border: '0',
              borderRadius: '0%'
            }
          },
          '28': {
            // Right-end hash mark
            label: '',
            style: {
              display: 'block',
              transform: 'translate(0px, -6px)',
              width: '1px',
              height: '16px',
              border: '0',
              borderRadius: '0%'
            }
          }
        },
        process: dotsPos => [
          // x - min is the numerator
          // max - min is the denominator
          // multiply by 100 to get whole number
          [
            0,
            Math.min(
              (5 - this.sliderOptions.min) / (this.sliderOptions.max - this.sliderOptions.min) * 100,
              dotsPos[0]
            ),
            { backgroundColor: '#0496E9' }
          ],
          [
            Math.min(
              (5 - this.sliderOptions.min) / (this.sliderOptions.max - this.sliderOptions.min) * 100,
              dotsPos[0]
            ),
            dotsPos[0],
            { backgroundColor: '#038CE0' }
          ],
          [
            Math.min(
              (13 - this.sliderOptions.min) / (this.sliderOptions.max - this.sliderOptions.min) * 100,
              dotsPos[0]
            ),
            dotsPos[0],
            { backgroundColor: '#105A9E' }
          ],
          [
            Math.min(
              (20 - this.sliderOptions.min) / (this.sliderOptions.max - this.sliderOptions.min) * 100,
              dotsPos[0]
            ),
            dotsPos[0],
            { backgroundColor: '#052C4F' }
          ]
        ],
        tooltip: 'none'
      }
    }
  },
  methods: {},
  mounted() {},
  watch: {
    newZoomLevel: function (newValue, oldValue) {
      this.$emit('zoomLevelChanged', newValue)
    },
    zoomLevel: function (newValue, oldValue) {
      this.newZoomLevel = newValue
    }
  }
}
</script>
